<template>
  <div id="map_target">
    <div id="mainMap"></div>
  </div>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
import {latLng, Icon, icon} from 'leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

export default {
  components: {
    'v-map': Vue2Leaflet.LMap,
    'v-tilelayer': Vue2Leaflet.LTileLayer,
    'v-icondefault': Vue2Leaflet.LIconDefault,
    'v-marker': Vue2Leaflet.LMarker,
    'v-popup': Vue2Leaflet.LPopup,
    'v-marker-cluster': Vue2LeafletMarkercluster
  },
  render: function (createElement) {
    return createElement('div', {attrs: {id: 'map_target'}})
  },
  updated: function () {
    setTimeout(() => {
      this.loadMarkers(true)
    }, 1000)
  },
  data () {
    let customicon = icon(Object.assign({},
      Icon.Default.prototype.options,
      {iconUrl, shadowUrl}
    ))
    return {
      map: null,
      icon: customicon,
      markersBatch: 500,
      clusterOptions: {},
      markerClusters: null,
      blockCounter: -1,
      initialLocation: latLng(37.0902, -95.7129),
      initMap: function () {
        if (this.map == null) {
          this.clusterOptions = { disableClusteringAtZoom: 11 }
          let L = window.L
          this.map = new L.Map('mainMap')
          var osmUrl = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
          var osmAttrib = 'Map &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
          var osm = new L.TileLayer(osmUrl, {minZoom: 3, maxZoom: 16, attribution: osmAttrib})
          this.map.setView(new L.LatLng(37.0902, -95.7129), 4)
          this.map.addLayer(osm)
        }
      },
      loadMarkers: function (reset) {
        if (reset) {
          if (this.markerClusters != null) {
            if (this.map.hasLayer(this.markerClusters)) {
              this.markerClusters.clearLayers()
              this.map.removeLayer(this.markerClusters)
            }
            this.markerClusters = null
          }
          this.blockCounter = -1
        }
        if (this.map != null && this.locations.length > 0) {
          let L = window.L
          this.blockCounter = this.blockCounter + 1
          if (this.markerClusters === null) {
            this.markerClusters = L.markerClusterGroup()
          }
          var sbIcon = L.icon({
            iconUrl: '/static/icon_24.png',
            iconRetinaUrl: '/static/icon_48.png',
            iconSize: [29, 24],
            iconAnchor: [9, 21],
            popupAnchor: [0, -14]
          })
          var moreMarkers = true
          for (var i = this.blockCounter * this.markersBatch; i < (this.blockCounter + 1) * this.markersBatch; i++) {
            if (this.locations[i]) {
              var locationData = this.locations[i]
              var popup = locationData.text
              var m = L.marker([locationData.lat, locationData.lng], {icon: sbIcon}).bindPopup(popup)
              this.markerClusters.addLayer(m)
            } else {
              moreMarkers = false
            }
          }
          this.map.addLayer(this.markerClusters)
          if (moreMarkers) {
            setTimeout(() => {
              this.loadMarkers()
            }, 200)
          }
        } else {
          setTimeout(() => {
            this.loadMarkers()
          }, 2500)
        }
      }
    }
  },
  mounted () {
    this.initMap()
    setTimeout(() => {
      this.$nextTick(() => {
        this.loadMarkers()
      })
    }, 1000)
    this.$store.subscribe(mutation => {
      if (mutation.type === 'ADD_FILTER') {
        this.$forceUpdate()
      }
    })
  },
  computed: {
    locations () {
      return this.$store.getters.locations
    }
  }
}
</script>

<style>
  @import "leaflet/dist/leaflet.css";
  @import "leaflet.markercluster/dist/MarkerCluster.css";
  @import "leaflet.markercluster/dist/MarkerCluster.Default.css";
  html, body {
    height: 100%;
    margin: 0;
  }
  #map_target,
  .vue2leaflet-map {
    min-height: 350px;
    margin-bottom: 16px;
    border-radius: 4px;
    background: #fff url('/static/spinner.gif') center center no-repeat;
  }
  #mainMap {
    position: relative;
    border-radius: 4px;
    height: 350px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/map.vue